var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"mb-1",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('label',{staticClass:"text__ mb-0",attrs:{"for":"name"}},[_vm._v(" Se ha enviando un correo para que puedas restaurar tu contraseña. Recuerda que ese link vence en 15 minutos. Y tendrás que generar uno nuevo. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }